import { GENERATED_BUILD_META } from "./generatedBuildMeta";

const DEFAULT_META = Object.freeze({
  version: "0.0.0",
  buildId: "unknown",
  builtAt: null,
});

let latestMeta = null;
let latestLoadPromise = null;

const safeFreeze = (value) => {
  try {
    return Object.freeze(value);
  } catch {
    return value;
  }
};

export const getBuildMetaSync = () => {
  return GENERATED_BUILD_META || DEFAULT_META;
};

export const loadBuildMeta = async () => {
  const meta = getBuildMetaSync();
  try {
    window.__APP_BUILD__ = meta;
  } catch {}
  return meta;
};

export const loadLatestBuildMeta = async ({ force = false } = {}) => {
  if (!force && latestLoadPromise) return latestLoadPromise;

  latestLoadPromise = (async () => {
    const publicUrl = process.env.PUBLIC_URL || "";
    const url = `${publicUrl}/build-meta.json`;
    try {
      const resp = await fetch(url, { cache: "no-store" });
      if (!resp.ok) throw new Error(`Failed to load build meta (${resp.status})`);
      const json = await resp.json();

      const version =
        typeof json?.version === "string" && json.version.trim()
          ? json.version.trim()
          : DEFAULT_META.version;
      const buildId =
        typeof json?.buildId === "string" && json.buildId.trim()
          ? json.buildId.trim()
          : DEFAULT_META.buildId;
      const builtAt =
        typeof json?.builtAt === "string" && json.builtAt.trim()
          ? json.builtAt.trim()
          : DEFAULT_META.builtAt;

      latestMeta = safeFreeze({ version, buildId, builtAt });
    } catch {
      latestMeta = null;
    }

    try {
      window.__APP_LATEST_BUILD__ = latestMeta;
    } catch {}

    return latestMeta;
  })();

  return latestLoadPromise;
};

